export const BUSINESS = {
  // Marque principale (v2 — rebrand février 2026)
  name: "AMB ÉLITE",
  brand: "AMB Élite",
  brandShort: "AMB Élite",
  // Signature de marque (overline chic affiché en petites capitales dorées)
  overline: "L'ART DE VOUS CONDUIRE",
  // Positionnement condensé (utilisé dans le Hero et les meta tags)
  positioning: "Maison de mobilité prestige · Côte d'Azur, Alpes, France",
  // Domaine cible — sera bascule sur ambelite.com une fois racheté chez OVH
  domain: "ambelite.com",
  domainTarget: "ambelite.com",
  phone: "+33680927670",
  phoneDisplay: "+33 6 80 92 76 70",
  // Adresse email principale pour tout (devis, contact, partenariats)
  emailContact: "amb.elite.alpes@gmail.com",
  email: "office@ambelite.com",
  // Adresse de secours discrète — page Contact uniquement
  emailBackup: "amb.elite.alpes@gmail.com",
  instagram: "https://www.instagram.com/amb.elite?utm_source=qr",
  // Direct Google Reviews URL — clients cliquent → laissent un avis 5 étoiles direct sur Google
  googleReviewUrl:
    "https://search.google.com/local/writereview?placeid=ChIJgznyYLICToAR9XvXVciWthQ&source=g.page.m.ia._&laa=nmx-review-solicitation-ia2",
  whatsapp: (text = "") =>
    `https://wa.me/33680927670${text ? `?text=${encodeURIComponent(text)}` : ""}`,
  // Open Graph image used by SEO meta tags (link previews on social / SMS)
  // Nouveau — nov. 2026 : logo officiel « road ivoire » (brand consistency)
  ogImage: "https://ambelite.com/logos/amb-road-ivory-og.jpg",
  // Profile avatar shown in the floating WhatsApp widget (round, click-to-WA)
  profileAvatar:
    "https://customer-assets.emergentagent.com/job_seasonal-driver-app/artifacts/accxjflh_IMG_6165.jpeg",
  // Nouvelles chartes graphiques AMB Élite (v2 — nov. 2026)
  // Mapping d'usage :
  //  • logoNavClair / logoNavSombre → Navbar (unique logo carré par thème — drapé ivoire / drapé noir)
  //  • logoSquareSombre  → Footer (road + fond noir soie — contraste)
  //  • logoRoadIvoryOG   → Open Graph / Twitter / aperçus réseaux sociaux
  //  • logoPrincipal     → /la-maison showcase (clean ivoire)
  //  • logoSignature     → signature email, inchangé
  logoNavClair: "/logos/amb-logo-ivory-new.webp",
  logoNavSombre: "/logos/amb-logo-black-new.webp",
  logoSquareSombre: "/logos/amb-road-dark.webp",
  logoRoadIvoryOG: "/logos/amb-road-ivory-og.jpg",
  logoPrincipal: "/logos/amb-clean-ivory.webp",
  logoSignature: "/logos/amb-signature-round-dark.png",
};

// Photos officielles AMB Élite — hébergées sur customer-assets.
const c = (slug) =>
  `https://customer-assets.emergentagent.com/job_seasonal-driver-app/artifacts/${slug}`;

// Free-to-use Unsplash photos.
const u = (id) =>
  `https://images.unsplash.com/${id}?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920`;

// Unsplash+ (premium) photos — served from plus.unsplash.com.
const up = (id) =>
  `https://plus.unsplash.com/${id}?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920`;

// Local client photos hosted from the frontend /public folder.
// Same-origin, cache-friendly, no external CDN dependency.
const p = (filename) => `/photos/${filename}`;

export const IMAGES = {
  // ── Hero / Riviera ──────────────────────────────────────────────
  heroSummer: u("photo-1491166617655-0723a0999cfc"), // Place Masséna Nice
  heroWinter: u("photo-1611572757951-6b8e7f068942"), // legacy (non affiché)
  rivieraCoast: u("photo-1604948559069-3287d5c5a6e5"), // côte rocheuse Côte d'Azur (Cap-Ferrat / Èze)

  // ── Photos client — Classe V AMB Élite ──────────────────────────
  vClassNight: c("t0ugwi9t_WhatsApp%20Image%202026-06-14%20at%2021.32.42.jpeg"), // V-Class de nuit, palmiers illuminés rue mouillée Côte d'Azur
  vClassPalace: c("accxjflh_IMG_6165.jpeg"),                                     // V-Class devant un palace
  interiorStarsNetflix: c("x2afi72i_IMG_4909.jpeg"),                             // Intérieur étoiles rouges + Netflix
  interiorStarsPrime: c("kc0utpv5_IMG_4913.jpeg"),                               // Intérieur étoiles bleues + Prime

  // ── Photos client — autres terrains ─────────────────────────────
  vClassRedStarsChogori: c("3larwomh_IMG_4296.jpeg"),                            // V-Class étoiles rouges, chalet Chogori
  vClassPurpleStarsTaos: c("rmep9dbf_IMG_4325.jpeg"),                            // V-Class étoiles violettes, Le Taos

  // ── Photos client NOUVELLES (juin 2026) ─────────────────────────
  vClassSunsetBoat: c("jyxmcyf3_WhatsApp%20Image%202026-06-14%20at%2021.32.43%20%281%29.jpeg"), // V-Class coucher de soleil avec yacht/paquebot derrière — golden hour Riviera
  vClassPalaceNight: c("75sajhgv_WhatsApp%20Image%202026-06-14%20at%2021.32.43%20%285%29.jpeg"), // V-Class devant un palais ornementé la nuit — VIP arrival
  vClassCortegeNight: c("wdtiomzx_WhatsApp%20Image%202026-06-14%20at%2021.32.43%20%284%29.jpeg"), // Plusieurs V-Class alignés la nuit — cortège / délégation
  vClassHotelBeauRivage: c("7miz2etz_WhatsApp%20Image%202026-06-14%20at%2021.32.43.jpeg"),       // V-Class de jour devant l'Hôtel Beau Rivage Nice

  // ── Flotte — vraies photos par classe Mercedes ──────────────────
  vClass: c("cwmmbqqv_IMG_6188.jpeg"),                                                  // V-Class réelle du client (carte flotte)
  sClass: c("819dwqh3_WhatsApp%20Image%202026-06-14%20at%2001.06.23.jpeg"),             // S-Class intérieur cuir cognac quilted + écrans
  eClass: c("jrljre6c_WhatsApp%20Image%202026-06-14%20at%2001.04.15.jpeg"),             // E-Class AMG Coupe noire face à la Méditerranée

  // ── Iconic visuals (FREE Unsplash) ──────────────────────────────
  redCarpetFestival: u("photo-1730878101449-fb9022e8b72d"), // Tapis rouge montant des marches dans un hôtel grand classique — esprit Festival de Cannes (sans branding visible)

  // ── Fallback / chauffeur ────────────────────────────────────────
  chauffeurSuit: u("photo-1730800328198-f9efbf9db53f"),        // homme en costard à côté d'une voiture noire (FREE)
  chauffeurDriving: u("photo-1596032457104-baa1f5f9372a"),     // chauffeur en costume noir au volant (FREE)
  vehicleInterior: u("photo-1432462770865-65b70566d673"),
  vehicleExterior: u("photo-1617209680907-4f9b76218a4b"),
  luxuryDoor: u("photo-1714348938110-d3692bc3716a"),

  // ── VIP chauffeur scenes (FREE Unsplash photos) ─────────────────
  chauffeurOpensDoor: u("photo-1730800328198-f9efbf9db53f"),   // chauffeur costard debout à côté voiture noire — alias
  chauffeurDrivingClose: u("photo-1514041181368-bca62cceffcd"), // chauffeur cinematic au volant

  // ═══ Nouveau lot photos client (juillet 2026) — /public/photos ═══
  // Riviera daytime — full car shots
  photoRivieraPinSea:       p("vclass-riviera-pin-sea.jpeg"),           // V-Class de profil sous un pin, mer bleue derrière — Riviera signature
  photoCapFerratDay:        p("vclass-cap-ferrat-day.jpeg"),            // V-Class jour devant Grand-Hôtel Cap-Ferrat, statues + colonnades
  photoCapFerratStatues:    p("vclass-cap-ferrat-statues.jpeg"),        // V-Class jour palace + statues romaines
  photoVillaProvencale:     p("vclass-villa-provencale.jpeg"),          // V-Class jour devant villa provençale, cyprès, verdure

  // Riviera nightscape — palaces & hôtels
  photoMonacoFront:         p("vclass-monaco-front-night.jpeg"),        // V-Class FACE hôtel de Paris Monaco palace la nuit
  photoMonacoFacade:        p("vclass-monaco-palace-facade.jpeg"),      // V-Class au premier plan avec palace Monaco en fond
  photoHotelParisButterflies: p("vclass-hotel-paris-butterflies.jpeg"), // V-Class devant hôtel de Paris Monaco + papillons lumineux — signature
  photoCapFerratNight:      p("vclass-cap-ferrat-night.jpeg"),          // V-Class de nuit devant Grand-Hôtel du Cap-Ferrat Four Seasons
  photoCapFerratDoorsOpen:  p("vclass-cap-ferrat-doors-open.jpeg"),     // V-Class portes ouvertes devant palace, sapins topiaires
  photoTerrassesEze:        p("vclass-terrasses-eze.jpeg"),             // V-Class portes ouvertes devant Terrasses d'Èze la nuit
  photoVClassPanameraVilla: p("vclass-panamera-villa-night.jpeg"),      // V-Class + Panamera devant villa moderne éclairée

  // Cortège / événements
  photoCortegeYacht:        p("cortege-vclass-yacht-night.jpeg"),       // 3-4 V-Class alignées yacht show la nuit
  // Fleet exception cars
  photoFleetExotic:         p("fleet-rolls-ferrari-bmw.jpeg"),          // Rolls Royce Phantom + Ferrari + BMW 7 alignés — véhicules d'exception
  photoSClassNoire:         p("sclass-noire.jpeg"),                     // Mercedes Classe S noire sous auvent

  // Intérieur signature
  photoInteriorPalaceView:  p("interior-stars-palace-view.jpeg"),       // Intérieur V-Class ciel étoilé + porte ouverte donnant sur palace via voûte de verdure
};

// Background photos for each Riviera destination tile (8 cities).
// Keys MUST match the strings in i18n RIVIERA_DESTINATIONS verbatim.
export const DESTINATION_PHOTOS = {
  "Nice": u("photo-1491166617655-0723a0999cfc"),                              // Place Masséna, Nice
  "Cannes": u("photo-1567599672391-17b31d92e431"),                            // White boats — Riviera (Croisette feel)
  "Monaco · Monte-Carlo": p("vclass-monaco-front-night.jpeg"),                // ⭐ Client photo — V-Class devant Hôtel de Paris Monaco
  "Saint-Tropez": u("photo-1693948882616-727d7a9f7934"),                      // Small boat at sea — Saint-Tropez vibe
  "Saint-Jean-Cap-Ferrat": p("vclass-cap-ferrat-night.jpeg"),                 // ⭐ Client photo — V-Class devant Grand-Hôtel Cap-Ferrat Four Seasons
  "Antibes · Juan-les-Pins": u("photo-1605373543615-9aec72041d20"),           // White boat blue sea — Antibes
  "Èze": p("vclass-terrasses-eze.jpeg"),                                      // ⭐ Client photo — V-Class devant Terrasses d'Èze night
  "Villefranche-sur-Mer": u("photo-1586605410212-eddadbd450f5"),              // Mediterranean greenery — Villefranche
};

// Winter destinations — Alpes stations. 3 priority stations (Val d'Isère,
// Tignes, Courchevel) shown first + Megève & Chamonix. Verbier dropped to
// keep photos unique. Client chalet photos (Chogori + Le Taos) headline
// the priority slots — 2 verified Unsplash alpine shots fill the rest.
// NOTE: client will send real Alps photos later — swap them in then.
export const ALPES_DESTINATIONS = [
  "Val d'Isère",
  "Tignes",
  "Courchevel 1850",
  "Megève",
  "Chamonix Mont-Blanc",
];

export const ALPES_PHOTOS = {
  "Val d'Isère":         u("photo-1551524559-8af4e6624178"),   // Skieur mid-jump sur pente enneigée
  "Tignes":              u("photo-1483664852095-d6cc6870702d"), // Coucher de soleil rose/orange sur forêt de pins enneigés
  "Courchevel 1850":     c("3larwomh_IMG_4296.jpeg"),           // ⭐ Client — V-Class + chalet Chogori
  "Megève":              c("rmep9dbf_IMG_4325.jpeg"),           // ⭐ Client — V-Class + Le Taos chalet luxe
  "Chamonix Mont-Blanc": u("photo-1544198365-f5d60b6d8190"),   // Sommets alpins golden hour — vibe Mont Blanc
};

// Hero slideshow — pivot hiver nov. 2026 : 85-90 % Alpes / stations
// enneigées, 1 slide Côte d'Azur en complément. Première slide = sommet
// alpin au coucher du soleil (vibration Mont-Blanc) pour poser immédiatement
// le positionnement montagne / stations de ski.
export const HERO_SUMMER_PHOTOS = [
  { id: u("photo-1544198365-f5d60b6d8190"),   alt: "Sommets alpins au coucher de soleil — Mont-Blanc et vallée enneigée, chauffeur privé stations de ski" },
  { id: c("3larwomh_IMG_4296.jpeg"),           alt: "Mercedes Classe V AMB Élite devant le chalet Chogori à Courchevel — transfert privé station de ski" },
  { id: u("photo-1483664852095-d6cc6870702d"), alt: "Coucher de soleil sur une forêt de pins enneigés — ambiance Tignes et Val d'Isère" },
  { id: c("rmep9dbf_IMG_4325.jpeg"),           alt: "Mercedes Classe V AMB Élite devant le chalet Le Taos — transfert aéroport vers station alpine" },
  { id: u("photo-1551524559-8af4e6624178"),    alt: "Skieur en pleine descente — stations alpines haut de gamme desservies par AMB Élite" },
  { id: u("photo-1491166617655-0723a0999cfc"), alt: "Place Masséna sous le soleil, Nice — service AMB Élite également disponible sur la Côte d'Azur" },
];

// ── Address book ─────────────────────────────────────────────────
// Full mailing-style addresses with postal codes — used when a user clicks
// a "Nice → Antibes" route or a destination tile. The form lands pre-filled
// with the real address (with zip code) so the client only has to refine
// the street if needed. Keys match the strings used in NiceTransfers' route
// hub label / `to` field and in `RIVIERA_DESTINATIONS` verbatim.
export const ADDRESS_BOOK = {
  // ── Airports / hubs ─────────────────────────────
  "Aéroport Nice": "Aéroport Nice Côte d'Azur, Rue Costes et Bellonte, 06206 Nice, France",
  "Aéroport Nice Côte d'Azur": "Aéroport Nice Côte d'Azur, Rue Costes et Bellonte, 06206 Nice, France",
  "Nice Côte d'Azur Airport": "Nice Côte d'Azur Airport, Rue Costes et Bellonte, 06206 Nice, France",
  "Aeroporto Nizza Costa Azzurra": "Aeroporto Nizza Costa Azzurra, Rue Costes et Bellonte, 06206 Nice, France",
  "Flughafen Nizza Côte d'Azur": "Flughafen Nizza Côte d'Azur, Rue Costes et Bellonte, 06206 Nice, France",
  "Aeropuerto Niza Costa Azul": "Aeropuerto Niza Costa Azul, Rue Costes et Bellonte, 06206 Nice, France",
  "مطار نيس كوت دازور": "مطار نيس كوت دازور, Rue Costes et Bellonte, 06206 Nice, France",

  // ── French Riviera destinations ─────────────────
  "Nice": "06000 Nice, France",
  "Cannes": "06400 Cannes, France",
  "Saint-Tropez": "83990 Saint-Tropez, France",
  "Cap-Ferrat": "06230 Saint-Jean-Cap-Ferrat, France",
  "Saint-Jean-Cap-Ferrat": "06230 Saint-Jean-Cap-Ferrat, France",
  "Antibes": "06600 Antibes, France",
  "Antibes · Juan-les-Pins": "06160 Juan-les-Pins, Antibes, France",
  "Èze": "06360 Èze, France",
  "Èze · Villefranche": "06360 Èze · Villefranche-sur-Mer, France",
  "Villefranche-sur-Mer": "06230 Villefranche-sur-Mer, France",
  "Monaco": "Principauté de Monaco, 98000 Monaco",
  "Monaco · Monte-Carlo": "Monte-Carlo, 98000 Monaco",
};

/**
 * Returns the full mailing address (with postcode) for a label if known,
 * otherwise returns the label itself so the prefill always works.
 */
export const fullAddress = (label) => ADDRESS_BOOK[label] || label;
